import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

const TOP_LEVEL_ID = 'unlink-note-before-void-modal';

interface UnlinkNoteBeforeVoidModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewNoteClick: () => void;
}

const UnlinkNoteBeforeVoidModal = ({
  isOpen,
  onClose,
  onViewNoteClick,
}: UnlinkNoteBeforeVoidModalProps) => {
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel`}
            leftIcon={FAIconName.XmarkRegular}
            onClick={onClose}
            variant="secondary"
          >
            Cancel
          </FireflyButton>

          <FireflyButton
            id={`${TOP_LEVEL_ID}__view-note`}
            leftIcon={FAIconName.externalLinkRegular}
            onClick={onViewNoteClick}
            variant="primary"
          >
            View note
          </FireflyButton>
        </ChakraFlex>
      }
      isOpen={isOpen}
      onClose={onClose}
      title="Unlink from note before voiding"
    >
      <Text>
        This document is attached to a patient note. To void this document,
        first open the note and remove the attachment.
      </Text>
    </ModalV2>
  );
};

export default UnlinkNoteBeforeVoidModal;
